import { defineWorld } from "@latticexyz/world";

export default defineWorld({
  namespace: "logistics",
  enums: {
    ProductStatus: ["ProductDppCreated", "LabVerified", "ReadyForConsumer"],
    BatchStatus: ["BatchRawDppCreated", "FieldSupervisorVerified", "ExportHandlerConfirmed", "Recalled"],
    RoleStatus: ["FieldSupervisor", "ExportHandler", "LabTechnician", "Manufacturer", "BrandRetailer", "ComplianceOfficer"]
  },
  tables: {
    //Product flow (not working)
    ProductRegistry: {
      schema: { gtin: "bytes14", productUuid: "bytes32", owner: "address", createdBy: "address", lastUpdatedBy: "address", status: "ProductStatus", didDocumentCid: "string" },
      key: ["gtin", "productUuid"],
    },
    ProductList: {
      schema: { index: "uint32", productGtin: "bytes14", productUuid: "bytes32" },
      key: ["index"],
    },
    ProductCount: {
      schema: { count: "uint32" },
      key: [],
    },
    ProductIndex: {
      schema: { productGtin: "bytes14", productUuid: "bytes32", index: "uint32" },
      key: ["productGtin", "productUuid"],
    },
    //Role management
    AdminRegistry: {
      schema: { admin: "address", isActive: "bool" },
      key: ["admin"],
    },
   
    WalletRole: {
      schema: { owner: "address", value: "RoleStatus", },
      key: ["owner"],
    },
    //VC management
    VCRegistry: {
      schema: { gtin: "bytes14", productUuid: "bytes32", vcHash: "bytes32", issuer: "address" },
      key: ["gtin", "productUuid"],
    },
    RoleVCRegistry: {
      schema: { gtin: "bytes14", productUuid: "bytes32", role: "uint8", vcHash: "bytes32", issuer: "address" },
      key: ["gtin", "productUuid", "role"],
    },
    AuthorizedIssuer: {
      schema: { issuer: "address", isActive: "bool", bbsPublicKey: "bytes" },
      key: ["issuer"]
    },
    CustodyLog: {
      schema: { gtin: "bytes14", productUuid: "bytes32", index: "uint32", from: "address", to: "address", status: "ProductStatus", timestamp: "uint64" },
      key: ["gtin", "productUuid", "index"]
    },
    CustodyCount: {
      schema: { gtin: "bytes14", productUuid: "bytes32", count: "uint32" },
      key: ["gtin", "productUuid"]
    },
    //Batch flow
    BatchRegistry: {
      schema: { batchGtin: "bytes14", batchUuid: "bytes32", owner: "address", createdBy: "address", lastUpdatedBy: "address", status: "BatchStatus", createdAt: "uint64", updatedAt: "uint64", didDocumentCid: "string" },
      key: ["batchGtin", "batchUuid"],
    },
    BatchList: {
      schema: { index: "uint32", batchGtin: "bytes14", batchUuid: "bytes32" },
      key: ["index"],
    },
    BatchCount: {
      schema: { count: "uint32" },
      key: [],
    },
    BatchIndex: {
      schema: { batchGtin: "bytes14", batchUuid: "bytes32", index: "uint32" },
      key: ["batchGtin", "batchUuid"],
    },
    BatchLinked: {
      schema: { batchGtin: "bytes14", batchUuid: "bytes32", isLinked: "bool" },
      key: ["batchGtin", "batchUuid"],
    },
    
    BatchTrace: {
      schema: { productGtin: "bytes14", productUuid: "bytes32", index: "uint32", batchGtin: "bytes14", batchUuid: "bytes32", linkedBy: "address", addedAt: "uint64" },
      key: ["productGtin", "productUuid", "index"],
    },
    BatchTraceCount: {
      schema: { productGtin: "bytes14", productUuid: "bytes32", count: "uint32" },
      key: ["productGtin", "productUuid"],
    },
    //NFC tag binding
    TagRegistry: {
      schema: {
        uid: "bytes7",
        batchGtin: "bytes14",
        batchUuid: "bytes32",
        activated: "bool",
        activatedBy: "address",
        activatedAt: "uint64",
      },
      key: ["uid"],
    },
    BatchTag: {
      schema: { batchGtin: "bytes14", batchUuid: "bytes32", uid: "bytes7", activated: "bool" },
      key: ["batchGtin", "batchUuid"],
    },
  },
});
